export default "/assets/images/critter-cuddler-crop.595aec1bcc345b42.webp";